import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    goalName: {
      marginLeft: spacing.xs,
    },
    goalLabel: {
      color: theme.exclusive.inverse.text,
      backgroundColor: theme.exclusive.inverse.background,
      fontSize: 12,
      fontWeight: 600,
      borderRadius: 4,
      padding: 3,
      display: "flex",
      marginLeft: spacing.xs,
    },
    exclusive: {
      flexShrink: undefined,
      flex: undefined,
    },
  };

  return styles;
};
